export default {"src":"/_next/static/media/marquee-employer.29d8c12e.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};